import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import { ptBR } from 'date-fns/locale';

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const isIsoDate = value => {
  if (!ISO_DATE_PATTERN.test(String(value || ''))) return false;

  const parsed = parseISO(value);
  return isValid(parsed) && format(parsed, 'yyyy-MM-dd') === value;
};

export const formatDatePtBr = value => {
  if (!isIsoDate(value)) return '';

  return format(parseISO(value), 'dd/MM/yyyy', { locale: ptBR });
};

export const clampDate = (value, { min, max } = {}) => {
  if (!isIsoDate(value)) return '';
  if (isIsoDate(min) && value < min) return min;
  if (isIsoDate(max) && value > max) return max;

  return value;
};

export const normalizeDateRange = ({ start, end } = {}) => {
  const normalizedStart = isIsoDate(start) ? start : '';
  const normalizedEnd = isIsoDate(end) ? end : '';

  if (normalizedStart && normalizedEnd && normalizedStart > normalizedEnd) {
    return { start: normalizedEnd, end: normalizedStart };
  }

  return { start: normalizedStart, end: normalizedEnd };
};
